import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import {
  LightbulbOutlined,
  AssignmentOutlined,
  CloudUploadOutlined,
  ShareOutlined,
} from '@mui/icons-material';

const HeroSection: React.FC = () => {
  const steps = [
    {
      number: 1,
      title: 'Lägg till kontroller',
      icon: AssignmentOutlined,
      description: 'Välj vilka kontroller du förbereder',
    },
    {
      number: 2,
      title: 'Ladda upp dokument',
      icon: CloudUploadOutlined,
      description: 'Samla allt på ett ställe',
    },
    {
      number: 3,
      title: 'Dela med inspektör',
      icon: ShareOutlined,
      description: 'Säker delning med lösenord',
    },
  ];

  return (
    <Box
      sx={{
        bgcolor: 'primary.pastel',
        borderRadius: '16px',
        mb: 3,
        border: '1px solid',
        borderColor: 'primary.light',
        overflow: 'hidden',
      }}
    >
      {/* Header section */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: { xs: 2, sm: 2.5 },
          py: 1.5,
          borderBottom: '1px solid',
          borderColor: 'primary.light',
          bgcolor: 'rgba(255, 255, 255, 0.3)',
        }}
      >
        <LightbulbOutlined sx={{ fontSize: 20, color: 'primary.dark' }} />
        <Typography
          variant="subtitle2"
          sx={{
            color: "text.primary",
            fontSize: '0.875rem',
            fontWeight: 600
          }}>
          Kom igång
        </Typography>
      </Box>

      {/* Steps section */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'stretch', sm: 'stretch' },
          p: { xs: 2, sm: 0 },
        }}
      >
        {steps.map((step, index) => {
          const StepIcon = step.icon;
          const isLast = index === steps.length - 1;
          return (
            <React.Fragment key={step.number}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'row', sm: 'column' },
                  alignItems: { xs: 'flex-start', sm: 'center' },
                  textAlign: { xs: 'left', sm: 'center' },
                  gap: { xs: 1.5, sm: 1 },
                  flex: 1,
                  py: { xs: 1, sm: 2 },
                  px: { xs: 0, sm: 2.5 },
                }}
              >
                {/* Step icon with number badge */}
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: '12px',
                      bgcolor: 'rgba(255, 255, 255, 0.6)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <StepIcon
                      sx={{
                        fontSize: 24,
                        color: 'primary.dark',
                      }}
                    />
                  </Box>
                </Box>

                {/* Step text */}
                <Box sx={{ flex: { xs: 1, sm: 'none' } }}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.primary",
                      fontWeight: 600,
                      fontSize: '0.8125rem',
                      lineHeight: 1.3
                    }}>
                    {step.number}. {step.title}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "text.secondary",
                      fontSize: '0.75rem',
                      lineHeight: 1.4,
                      display: 'block',
                      mt: 0.25
                    }}>
                    {step.description}
                  </Typography>
                </Box>
              </Box>

              {/* Divider between steps */}
              {!isLast && (
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    display: { xs: 'none', sm: 'block' },
                    borderColor: 'primary.light',
                    my: 1.5,
                  }}
                />
              )}
              {!isLast && (
                <Divider
                  sx={{
                    display: { xs: 'block', sm: 'none' },
                    borderColor: 'primary.light',
                    my: 0.5,
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};

export default HeroSection;
